export default "__VITE_ASSET__44d8bbe6__"